// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/x.js';

import { paths } from '../generated/x';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('x', Original, paths);
